import { Row, Space, Typography } from 'antd';
import React from 'react';
import OptionsList from './OptionsList';

interface SmartFormPredictOptionsProps {
  message: {
    text: string;
    metadata?: {
      subscriptionOptions: React.ComponentProps<
        typeof OptionsList
      >['subscriptionOptions'];
    };
  };
  onSelect: React.ComponentProps<typeof OptionsList>['onSelect'];
  showOptions?: boolean;
}

const { Text } = Typography;

const SmartFormPredictOptions = function ({
  message,
  onSelect,
  showOptions = false,
}: SmartFormPredictOptionsProps) {
  const { metadata: { subscriptionOptions } = {} } = message;

  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <Row justify="center">
        <Text>{message.text}</Text>
      </Row>
      <OptionsList
        onSelect={onSelect}
        subscriptionOptions={subscriptionOptions}
        showOptions={showOptions}
      />
    </Space>
  );
};

export default SmartFormPredictOptions;
